import cx from 'classnames';
import Toggle from '../../../../components/Toggle/Toggle';
import React, { useCallback } from 'react';
import styles from './PreferenceSwitch.module.scss';

export const PreferenceSwitch = ({ item, className }) => {
  const { text, isOn, action, key, disabled } = item;

  return (
    <div className={cx(styles.switchContainer, className, { [styles.disabled]: disabled })}>
      <span>{text}</span>
      <Toggle id={text} checked={isOn} onChange={action} size="medium" key={key} disabled={disabled} />
    </div>
  );
};
